<template>
  <div
    id="Modal-Send-product"
    class="card shadow m-3 position-fixed right-0 top-0"
    style="z-index:9999;top:80px;transition: 0.25s;min-width: 420px;"
    v-show="showModal"
  >
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div
          :class="{'rotate': !complete}"
          class="mr-2 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
          style="width:50px; height:50px;"
        >
          <i class="fa-solid fa-hourglass-half fa-2x" />
        </div>

        <div class="flex-fill">
          <div
            class="progress rounded-round mb-2"
            style="height:12px"
          >
            <div
              class="progress-bar bg-primary rounded-round"
              :style="`width:${progressBarWidth}%;`"
            >
              <!-- <span class="label-percent"></span> -->
            </div>
          </div>
          <div>
            {{ $t('Sending product to Salesforce system') + '...' }}
          </div>
        </div>
        <button
          :class="{'text-muted cursor-default': !canCloseModal}"
          @click="closeModal()"
          type="button"
          class="close align-self-start ml-2 mr-n1 mt-n2"
        >
          <span>×</span>
        </button>
      </div>
      <div 
        @click="showResponseMessage = !showResponseMessage"
        class="mt-2 text-primary cursor-pointer text-underline dropdown-toggle"
      >
        {{ $t("Response Message") }}
      </div>
      <div 
        v-show="showResponseMessage"
        class="list-send-msg"
      >
        <template v-for="(msg, i) in message">
          <div
            :key="`msg-${i}`"
            :class="msg.cssResponseMessage" 
            v-html="msg.responseMessage" 
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        const vm = this;
        return {
            canCloseModal: false,
            // listMsg: [],
            finalEvent: false,
            totalSend: 0,
            countSend: 0,
            actionList: [],
            // showLogError: false,
            showModal: false,
            responseMessage: '',
            showResponseMessage: false,
            cssResponseMessage: '',
            parentDataThis: null,
            message: []
        }
    },
    computed: {
        progressBarWidth() {
            return this.countSend * 100 / this.totalSend;
        },
        complete() {
            return this.countSend == this.totalSend;
        }
    },
    methods: {
      closeModal() {
        if(!this.canCloseModal) return;
        this.$store.dispatch("product/isModalSendProduct", false);
      },
    },
    filters: {
        replaceText: function (text, countOrderSend, totalSend) {
            text = text.replace('{totalSend}', totalSend);
            text = text.replace('{countOrderSend}', countOrderSend);
            return text;
        }
    },
}
</script>
<style scoped>
  .card {
    box-shadow: 0 1px 2px rgba(0,0,0,.05)!important;
  }
  .list-send-msg {
    overflow-y: auto;
    max-height:400px;
  }
  .list-send-msg > div {
    padding-left: 1.25rem ;
    padding-top: .3125rem ;
    padding-bottom: .3125rem ;
    border-top: 1px solid #ddd ;
  }
  .list-send-msg > div:first-child {
    border-top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/products/ModalSendProduct.vue